import Blob from "cross-blob";
import {
  Document,
  HeadingLevel,
  ISectionOptions,
  Packer,
  Paragraph,
  TextRun,
} from "docx";
import flattenDeep from "lodash/flattenDeep";

import { docStyles } from "./common";
import { numberingStyle } from "./common/numbering";
import { DocGenerator } from "../";
import { renderProseMirrorSchemaToGoogleDoc } from "../proseMirror";
import { ApplicationFull } from "../../prisma";

interface RefereeDocArgs {
  application: ApplicationFull;
}

export const createPlansDoc: DocGenerator<RefereeDocArgs> = async (t, arg) => {
  const document = new Document({
    styles: docStyles,
    numbering: numberingStyle,
    sections: [
      {
        children: flattenDeep<ISectionOptions["children"][0] | null>([
          new Paragraph({
            children: [
              new TextRun({
                text: "Applicant: ",
              }),
              new TextRun({
                text: arg.application.applicant.fullName
                  ? arg.application.applicant.fullName
                  : `${arg.application.applicant.firstName} ${arg.application.applicant.lastName}`,
              }),
            ],
            heading: HeadingLevel.TITLE,
          }),

          new Paragraph({
            children: [
              new TextRun({
                text: "Plans: ",
              }),
            ],
            heading: HeadingLevel.TITLE,
          }),

          renderProseMirrorSchemaToGoogleDoc(arg.application.dream, "-"),

          new Paragraph({
            style: "wellSpaced",
          }),

          new Paragraph({
            children: [
              new TextRun({
                text: "Benefit: ",
              }),
            ],
            heading: HeadingLevel.TITLE,
          }),

          renderProseMirrorSchemaToGoogleDoc(arg.application.benefit, "-"),
        ]).filter((x): x is ISectionOptions["children"][0] => x !== null),
      },
    ],
  });

  return new Blob([await Packer.toBuffer(document)]);
};
